export default function NavbarSearchIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M427.36,412.23l-97.65-97.65c26.13-28.08,40.48-64.47,40.48-102.82,0-83.32-67.78-151.1-151.1-151.1S67.99,128.44,67.99,211.76s67.78,151.1,151.1,151.1c31.23,0,61.12-9.45,86.62-27.36l99.19,99.19c3,3,6.99,4.65,11.23,4.65s8.23-1.65,11.23-4.65c6.19-6.19,6.19-16.26,0-22.45ZM338.43,211.76c0,65.81-53.54,119.34-119.34,119.34s-119.34-53.54-119.34-119.34,53.54-119.34,119.34-119.34,119.34,53.54,119.34,119.34Z" />
    </svg>
  );
}
